//import { inject } from 'aurelia-framework';
//import { ThemeManager } from './theme-manager';
//import { Settings } from './settings';

//@inject(ThemeManager, Settings)
//export class ThemeSelector {

//    themes = [
//        { value: 'bootstrap-theme', name: 'Bootstrap Blue', colors: ['#2F70A7', '#fff'] },
//        { value: 'default-theme', name: 'Default', colors: ['#179BD7', '#fff'] },
//        { value: 'flat-azure-dark', name: 'Azure Dark (flat)', colors: ['#179BD7','#373737'] },
//        { value: 'flat-lime', name: 'Lime (flat)', colors: ['#AECF49', '#fff'] },
//        { value: 'flat-lime-dark', name: 'Lime Dark (flat)', colors: ['#AECF49', '#373737'] },
//        { value: 'flat-saffron', name: 'Saffron', colors: ['#F9920B', '#fff'] },
//        { value: 'flat-saffron-dark', name: 'Saffron Dark', colors: ['#F9920B', '#373737'] },
//        { value: 'gradient-azure', name: 'Azure', colors: ['#6CC0E6', '#fff'] },
//        { value: 'gradient-azure-dark', name: 'Azure Dark', colors: ['#34A7DC', '#373737'] },
//        { value: 'gradient-lime', name: 'Lime (gradient)', colors: ['#BDD86C', '#fff'] },
//        { value: 'gradient-lime-dark', name: 'Lime Dark (gradient)', colors: ['#B4D357', '#373737'] },
//        { value: 'gradient-saffron', name: 'Saffron (gradient)', colors: ['#FAA739', '#fff'] },
//        { value: 'gradient-saffron-dark', name: 'Saffron Dark (gradient)', colors: ['#FAA93E', '#373737'] }
//        ];

//    constructor(private themeManager :ThemeManager, private settings:Settings) {
//        this.themeManager = themeManager;
//        this.settings = settings;
//    }

//    selectTheme(theme) {
//        jQuery('body').fadeOut(400, () => {
//            this.settings.activeTheme = theme.value;
//            this.themeManager.loadTheme(theme.value)
//                .then(() => jQuery('body').fadeIn());
//        });
//    }
//}